// import './BOShippingInfo.scss';
import './styles.scss';

import Proptypes from 'prop-types';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import ModalComponent from '@components/Share/ModalComponent';
import SFExpressPopup from '@components/SlicingPage/CartDetails/SFExpressPopup';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { ASSEMBLE_OPTION_KEY, DELIVERY_OPTION } from '@utils/constant';
import { useDidUpdateEffect } from '@utils/customsHook/useDidUpdateEffect';

import PickupFromStore from '../../BuyingOptions/BOShippingInfo/PickupFromStore';
import { useCheckEnableBundleBOPISOption, useGetBundleAvailabilityStores } from './hooks';

const BundleBOShippingInfo = (props) => {
  const {
    deliveryOptions,
    deliveryStatus,
    dataTextFields,
    dataFields,
    freegiftSelected,
    allowedOptions
  } = props;
  const dispatch = useDispatch();
  const checkEnableBundleBOPIS = useCheckEnableBundleBOPISOption();
  const getBundleAvailabilityStoresService = useGetBundleAvailabilityStores();
  const [isShowSFExpress, setShowSFExpress] = useState(false);
  const bundleProductsList = useMemo(() => dataFields?.Products || [], [dataFields]);
  const bundleFreeGiftsList = useMemo(() => dataFields?.FreeGift || [], [dataFields]);

  const isEnableBOPISOption = useMemo(() => checkEnableBundleBOPIS({
    bundleProductsList,
    bundleFreeGiftsList,
    allowedOptions
  }), [bundleProductsList, bundleFreeGiftsList, allowedOptions]);

  const isSelectedFreeGiftHasBOPIS = useMemo(
    () => freegiftSelected?.length ? freegiftSelected.every((item) => item.HasBOPISOption) : false,
    [freegiftSelected]
  );

  const isHasSelectedAssemble = useMemo(() => bundleProductsList.some((productItem) => {
    const assemblyOptionData = productItem.AdditionalOptions?.find((optionItem) => optionItem?.RelationshipId
      === ASSEMBLE_OPTION_KEY);
    if (assemblyOptionData) {
      return assemblyOptionData.Products?.some((product) => product.IsChoseAdditionalOption);
    }

    return false;
  }), [JSON.stringify(bundleProductsList)]);

  const isShowStoresList = useMemo(
    () => isEnableBOPISOption && (isSelectedFreeGiftHasBOPIS || true) && !isHasSelectedAssemble,
    [isEnableBOPISOption, isSelectedFreeGiftHasBOPIS, isHasSelectedAssemble]
  );

  const activeVariantAll = useMemo(
    () => dataFields?.['Active Variant All'] || [],
    [JSON.stringify(dataFields?.['Active Variant All'])]
  );

  useEffect(() => {
    if (!isSelectedFreeGiftHasBOPIS && !freegiftSelected?.length) {
      (
        async () => {
          await getBundleAvailabilityStoresService({
            bundleProductsList,
            bundleFreeGiftsList,
            allowedOptions
          });
        }
      )();
    }
  }, []);

  useDidUpdateEffect(
    () => {
      if ((
        isSelectedFreeGiftHasBOPIS && freegiftSelected?.length
      ) || activeVariantAll.some(variantItem => variantItem.isClickedVariant
        || bundleProductsList?.some(productItem => productItem.AdditionalOptions.some((optionItem) => optionItem.Products?.some(
          (optionProductItem) => optionItem.RelationshipId
            !== ASSEMBLE_OPTION_KEY
            && optionProductItem.IsChoseAdditionalOption))))) {
        (
          async () => {
            await getBundleAvailabilityStoresService({
              bundleProductsList,
              bundleFreeGiftsList,
              allowedOptions,
              freeGiftSelected: freegiftSelected
            });
          }
        )();
      }
    },
    [
      isSelectedFreeGiftHasBOPIS,
      JSON.stringify(freegiftSelected),
      JSON.stringify(activeVariantAll),
      JSON.stringify(bundleProductsList)
    ]
  );

  const onCloseModalHandler = () => {
    setShowSFExpress(false);
  };

  return (
    <div className='shipping-info shipping-info__with-bopis'>
      <div className='shipping-info__wrap container'>
        {deliveryOptions?.length
          ? deliveryOptions.map((deliveryItem) => (
            <div
              className={[
                'shipping-info__item shipping-info--delivery',
                DELIVERY_OPTION.PickUpStore === deliveryItem.ShippingOptionType.Value ? 'shipping-info__item-bopis' : ''
              ].join(' ')}
              key={deliveryItem.ExternalId}
            >
              {DELIVERY_OPTION.PickUpStore !== deliveryItem.ShippingOptionType.Value ? (
                <div className='shipping-info__item__icon'>
                  {DELIVERY_OPTION.ShipItem === deliveryItem.ShippingOptionType.Value ? (
                    <div className='fulfillment-icon fulfillment-icon--ship-item'></div>
                  ) : (
                    ''
                  )}
                  {DELIVERY_OPTION.SFExpress === deliveryItem.ShippingOptionType.Value ? (
                    <div className='fulfillment-icon fulfillment-icon--sf-express'></div>
                  ) : (
                    ''
                  )}
                  {DELIVERY_OPTION.DeliveryBySFExpress === deliveryItem.ShippingOptionType.Value ? (
                    <div className='fulfillment-icon fulfillment-icon--delivery-sf-express'></div>
                  ) : (
                    ''
                  )}
                </div>
              ) : (
                <></>
              )}

              <div className='shipping-info__item__text bundle-layout'>
                {DELIVERY_OPTION.PickUpStore !== deliveryItem.ShippingOptionType.Value ? (
                  <div className='shipping-info__item__text__title'>{deliveryItem.Name}</div>
                ) : (
                  <></>
                )}
                {/* <span className='shipping-info__item__text__desc'>
                  {DELIVERY_OPTION.ShipItem !== deliveryItem.ShippingOptionType.Value ? deliveryItem.Description : null}
                </span> */}

                {DELIVERY_OPTION.SFExpress === deliveryItem.ShippingOptionType.Value ? (
                  <Fragment>
                    <span className='shipping-info__item__text__desc'>
                      <Text className='smaller-text' field={dataTextFields['Available Label']} tag='span' />
                      <span className='shipping-info__item__text__desc link-store'>
                        <Text
                          className='smaller-text--inline smaller-text--underline'
                          onClick={() => setShowSFExpress(true)}
                          tag='span'
                          field={dataTextFields['SF Express Station Label']}
                        />
                      </span>
                    </span>
                  </Fragment>
                ) : null}

                {DELIVERY_OPTION.ShipItem === deliveryItem.ShippingOptionType.Value ? (
                  <span className='shipping-info__item__text__desc'>{deliveryStatus}</span>
                ) : null}

                {DELIVERY_OPTION.PickUpStore === deliveryItem.ShippingOptionType.Value ? (
                  <PickupFromStore
                    key={deliveryItem.ExternalId}
                    name={deliveryItem.Name}
                    addressSetting={dataTextFields?.['Address Settings']}
                    isShowStoresListProp={isShowStoresList}
                  />
                ) : (
                  <></>
                )}

                {DELIVERY_OPTION.DeliveryBySFExpress === deliveryItem.ShippingOptionType.Value ? (
                  <Fragment>
                    <span className='shipping-info__item__text__desc'>
                      <span className='smaller-text'>{deliveryItem?.Description}</span>
                    </span>
                  </Fragment>
                ) : null}
              </div>
            </div>
          ))
          : ''}
      </div>
      <ModalComponent
        isShow={isShowSFExpress}
        onCloseHandler={onCloseModalHandler}
        titlePopup={<Text field={dataTextFields['SF Express Popup Title']} />}
      >
        <SFExpressPopup dataSources={dataTextFields} />
      </ModalComponent>
    </div>
  );
};

BundleBOShippingInfo.propTypes = {
  deliveryOptions: Proptypes.array,
  deliveryStatus: Proptypes.any,
  dataTextFields: Proptypes.any,
  dataFields: Proptypes.any,
  freegiftSelected: Proptypes.any,
  allowedOptions: Proptypes.any
};

export default BundleBOShippingInfo;
